import { Component, Inject, OnInit } from '@angular/core';
import { CustomerContactService } from '../../customer-contact/add-new-user-cl/customer-contact.service';
import { crsfNewVM, crsfVM, JSLVM_USER } from '../../customer-contact/Models/customer-contact.model';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-jobsite-uc',
  templateUrl: './add-new-jobsite-uc.component.html',
  styleUrls: ['./add-new-jobsite-uc.component.scss']
})
export class AddNewJobsiteUcComponent implements OnInit {

  constructor( public dialogRef:MatDialogRef<AddNewJobsiteUcComponent>,
    private _customerContactService:CustomerContactService,
    private _customerService:CustomerService,
    @Inject(MAT_DIALOG_DATA) public data:any,
    ) { }

    CustomerList:any
    selectedCustomer:number=1
    JobsiteListForTab:crsfVM[];
    JobsiteList:crsfNewVM[];
    jobsitebyCustomerID:crsfNewVM[]
    array1:any[] = [];
    array2:any[] = [];
    selectedOptions1:any = [];
    selectedOptions2:any = [];
    userId:number
    

  ngOnInit() {
    this.userId=this.data.userId;
    this.JobsiteListForTab=this.data.JobsiteListForTab
    console.log("JobsiteListForTab", this.JobsiteListForTab)
    this.GetCustomerDetails();
  }

  DialogClose(){
    this.dialogRef.close(false)
  }

  GetCustomerDetails(){
    this._customerContactService.GetCustomerDetails().subscribe(res=>{
      this.CustomerList = res;
      res.map(x=>{x.customerName
      x.customerId})
      console.log("this.customerlist",this.CustomerList);
  })
  }

  onChangeCustomer(){
    this.GetJobSiteDetails();  
  }

  GetJobSiteDetails(){  
    let temparr=[]
    this._customerService.getCrsfInfo_().subscribe(res=>{
      this.JobsiteList = res
      this.jobsitebyCustomerID= this.JobsiteList.filter(x=>x.customer_auto == this.selectedCustomer);
      console.log("this.jobsitebyCustomerID",this.jobsitebyCustomerID);
      this.array1=this.jobsitebyCustomerID   
      this.JobsiteListForTab.map(x=>{
        let checkhasexisitng = this.array1.find(z => z.crsf_auto == x.crsf_auto);
        if(checkhasexisitng)
        {
           temparr.push(x)
          this.array2=temparr
          this.array1 = this.array1.filter(z=>z.crsf_auto!=x.crsf_auto);
        }
        else
        this.array2=temparr
      }) 

  });
  }


  AddItem() {
    console.log("selectedoption 1", this.selectedOptions1)
   
    console.log("this.array1before",this.array1)
    if (this.selectedOptions1.length > 0) {
      this.selectedOptions1.map(x=> {
        if (this.array2.length > 0) {
          let checkhasexisitng = this.array2.find(z => z.crsf_auto == x.crsf_auto);
          if (!checkhasexisitng) {
            this.array2.push(x);

            this.array1 = this.array1.filter(z=>z.crsf_auto!=x.crsf_auto);
            console.log("this.array1____",this.array1)
    
           
          }
        } 
        else {
          this.array2.push(x);
          this.array1 = this.array1.filter(z=>z.crsf_auto!=x.crsf_auto);
         // this.array1.pop(x)
        }
      });
    }
  }


  RemoveItem() {
    if (this.selectedOptions2.length > 0) {
      this.selectedOptions2.map(x => {
        this.array2 = this.array2.filter(z => z.crsf_auto != x.crsf_auto);
        this.array1.push(x);
        this.selectedOptions2 = [];
      });
    }
  }
  
  
  AddNewJobSitetoUser(){
  let useridarray:any[]=[];
  let cusidarray:any[]=[];
  if(this.array2.length>0)
  {
    this.array2.map(item =>{if(item.crsf_auto){
      useridarray.push(item.crsf_auto)
    }}
    )
  }
  
    let params = new  JSLVM_USER();
    params.customer_auto=this.selectedCustomer;
    params.user_auto=Number(this.userId);
    params.EvalA=true;
    params.EvalB=true;
    params.EvalC=true;
    params.EvalX=true;
    params.crsf_auto=useridarray;
    params.Type='SITE';
    
    this._customerService.AddNewJobSitetoUser(params).subscribe(res=>{
      console.log("result",res);
      if(res==true)
      {
        this.DialogClose();
      }
    })
   // console.log("this.selectedUserId",this.userId);
    //console.log("this.selectedSiteID",this.selectedSiteId)   
}

}
